import React from "react"
import JobsImg from "../../../images/jobs-img.svg"

const Hero = ({ position_name, location_display }) => {
  return (
    <section className="container mx-auto pt-8 lg:pt-24 px-6 pb-20">
      <div className="flex flex-col-reverse md:flex-row md:items-center">
        <div className="w-full md:w-1/2 leading-tight">
          <h1 className="text-5xl font-light pb-8 leading-tight">
            <span className="text-secondary font-bold"></span>{position_name}
          </h1>
          <h4 className="text-xl pb-8">{location_display}</h4>
          <p className="leading-7">
          <b>Avalith</b> is growing fast and we are looking for <b>people</b> who want to work with peers and clients who <b>enjoy creating great products together.</b>
          </p>
        </div>
        <div className="hidden md:block w-full md:w-1/2">
          <img
            src={JobsImg}
            alt="Avalith está creciendo rápidamente y estamos buscando personas que
              quieran trabajar con pares y clientes que disfruten y creen
              excelentes productos juntos"
            width="300"
            className="mx-auto"
          />
        </div>
      </div>
    </section>
  )
}
export default Hero